var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Upload',{staticStyle:{"display":"inline-block"},attrs:{"action":_vm.fileUploadURL,"headers":_vm.uploadHeaders,"accept":_vm.accept,"show-upload-list":false,"on-success":_vm.importFileSuccess,"on-error":_vm.importFileError,"before-upload":_vm.beforeUpload}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }